import { Fab } from '@mui/material'
import React from 'react'
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import AppointmentModal from '../Modal/AppointmentModal/AppointmentModal';
import { UniversalContext } from '../../context/UniversalContext/UniversalContext';

const FloatingButton = () => {

    const {appointmentModal, setAppointmentModal} = React.useContext(UniversalContext)

    return (
    <>
        <Fab variant="extended" style={{
            position: "fixed",
            right: 0,
            bottom: "50%",
            borderRadius: "1rem 0 0 2rem"
        }}
        color='success'
        onClick={() => setAppointmentModal(true)}
        >
            <EditLocationAltIcon sx={{ mr: 1 }} />
            Book Appointment
        </Fab>
        {appointmentModal && <AppointmentModal />}
    </>
    )
}

export default FloatingButton